/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/


//column heads for audit log list
export const columns: TableColumn[] = [
      {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "auditTrialReport.tableColumns.user",
        accessor: "user",
      },
      {
        Header: "auditTrialReport.tableColumns.dateAndTime",
        accessor: "dateAndTime",
      },
      {
        Header: "auditTrialReport.tableColumns.event",
        accessor: "typeOfOperation",
      },
      {
        Header: "auditTrialReport.tableColumns.guiName",
        accessor: "apiGuiName",
      },
      {
        Header: "auditTrialReport.tableColumns.UniqueIdentifier",
        accessor: "master_data",
      },
      {
        Header: "auditTrialReport.tableColumns.reason",
        accessor: "reason",
      },
      
]


interface TableColumn {
    Header: string;
    accessor: string;
  }